function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import * as Icons from '../Icon';
import { CopyToClipboard } from '../../index';

const SplitTag = ({
  leftValue,
  leftIcon = 'Lock',
  rightValue,
  rightIcon = 'Verified',
  variant = 'error-success',
  size,
  defaultValue = '-',
  valueMaxWidth = '2.8rem',
  isFixedWidth = true,
  className = '',
  style = {},
  ...props
}) => {
  const [leftCopied, setLeftCopied] = useState(false);
  const [rightCopied, setRightCopied] = useState(false);
  const timeoutLeft = useRef(null);
  const timeoutRight = useRef(null);

  const onCopyLeft = (_text, result) => {
    if (isFixedWidth === false) return;
    setLeftCopied(result);
    timeoutLeft.current = setTimeout(() => {
      setLeftCopied(null);
      timeoutLeft.current = null;
    }, 2000);
  };

  const onCopyRight = (_text, result) => {
    if (isFixedWidth === false) return;
    setRightCopied(result);
    timeoutRight.current = setTimeout(() => {
      setRightCopied(null);
      timeoutRight.current = null;
    }, 2000);
  };

  useEffect(() => {
    return function clearCopyTimeout() {
      if (timeoutLeft.current) {
        clearTimeout(timeoutLeft.current);
      }

      if (timeoutRight.current) {
        clearTimeout(timeoutRight.current);
      }
    };
  }, []);
  const leftComponentName = `Icon${leftIcon}`;
  const LeftIconComponent = leftIcon && Icons[leftComponentName];
  const rightComponentName = `Icon${rightIcon}`;
  const RightIconComponent = rightIcon && Icons[rightComponentName];
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classnames(className, 'tag-split', `tag-split--${variant}`, {
      'tag-split--sm': size === 'sm',
      'tag-split--lg': size === 'lg',
      'tag-split--fixed-width': isFixedWidth
    }),
    style: style
  }, props), /*#__PURE__*/React.createElement(CopyToClipboard, {
    text: leftValue,
    onCopy: onCopyLeft
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      cursor: isFixedWidth && 'pointer'
    },
    "data-tooltip": isFixedWidth ? leftCopied ? 'Copied' : leftValue : null
  }, /*#__PURE__*/React.createElement(LeftIconComponent, null), "\xA0", isFixedWidth ? /*#__PURE__*/React.createElement("div", {
    className: "_text-overflow:ellipsis",
    style: {
      width: valueMaxWidth
    }
  }, leftValue !== undefined ? leftValue : defaultValue) : leftValue !== undefined ? leftValue : defaultValue)), /*#__PURE__*/React.createElement(CopyToClipboard, {
    text: rightValue,
    onCopy: onCopyRight
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      cursor: isFixedWidth && 'pointer'
    },
    "data-tooltip": isFixedWidth ? rightCopied ? 'Copied' : rightValue : null
  }, isFixedWidth ? /*#__PURE__*/React.createElement("div", {
    className: "_text-overflow:ellipsis",
    style: {
      width: valueMaxWidth
    }
  }, rightValue !== undefined ? rightValue : defaultValue) : rightValue !== undefined ? rightValue : defaultValue, "\xA0", /*#__PURE__*/React.createElement(RightIconComponent, null))));
};

SplitTag.propTypes = {
  leftValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  leftIcon: PropTypes.string,
  rightValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  rightIcon: PropTypes.string,
  variant: PropTypes.oneOf(['error-success', 'info-success', 'warning-success']),
  size: PropTypes.oneOf(['sm', 'lg']),
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  valueMaxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isFixedWidth: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object
};
export default SplitTag;